export const URL_FAQ = `https://schaeffler.sharepoint.com/sites/Digitalization-and-IT/SitePages/FAQ(2).aspx`;
export const URL_MY_SCHAEFFLER = `https://schaeffler.sharepoint.com/sites/Digitalization-and-IT/SitePages/Cost-Database-Analytics.aspx`;
export const URL_ROLE_ASSIGNMENTS = `https://schaeffler.sharepoint.com/sites/Digitalization-and-IT/SitePages/Rights-%26-Roles.aspx`;
export const URL_GET_ACCESS = `https://schaeffler.sharepoint.com/sites/Digitalization-and-IT/SitePages/Get-Access.aspx`;

export const URL_SAMS_1 = `https://webhp1.schaeffler.com:62839/sap/bc/webdynpro/SGD/bc_sams_ep_wda?sap-client=100`;

export const URL_SAMS_2_CREATE_TICKET = `https://schaefflerprod.service-now.com/sup?id=sc_cat_item&sys_id=2d1e91cfdb5ba20038c2b6bffe961953&sysparm_category=19634e32dbb73e00d624b14ffe961977`;
export const URL_SAMS_2_REQUEST_AUTHORIZATION = `https://schaefflerprod.service-now.com/sup?id=sc_cat_item&sys_id=19c1f2d9474a551034c874bd436d43ff&sysparm_category=69bbcbde1b22c014503297539b4bcba0`;

export const URL_SUPPORT = `https://schaefflerprod.service-now.com/sup`;

export const URLS_AUTH: string[] = [
  'https://login.microsoftonline',
  'https://login.partner.microsoftonline',
  'https://graph.microsoft.com',
];
